/* Lala & Stitch — theme.js */
(function () {
  'use strict';

  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));

  /* ---------- Toast ---------- */
  let toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('show'), 2200);
  }

  /* ---------- Mobile menu ---------- */
  const menuBtn = $('[data-menu-open]');
  const mobileDrawer = $('[data-mobile-drawer]');
  const overlay = $('[data-overlay]');

  function openMobile() {
    mobileDrawer && mobileDrawer.classList.add('open');
    overlay && overlay.classList.add('open');
  }
  function closeMobile() {
    mobileDrawer && mobileDrawer.classList.remove('open');
    overlay && overlay.classList.remove('open');
  }
  menuBtn && menuBtn.addEventListener('click', openMobile);
  $$('[data-menu-close]').forEach((b) => b.addEventListener('click', closeMobile));
  $$('.mobile-drawer a').forEach((a) => a.addEventListener('click', closeMobile));

  /* ---------- Header search toggle ---------- */
  const searchToggle = $('[data-search-toggle]');
  const headerSearch = $('[data-header-search]');
  searchToggle &&
    searchToggle.addEventListener('click', () => {
      headerSearch.classList.toggle('open');
      if (headerSearch.classList.contains('open')) {
        const input = $('input', headerSearch);
        input && input.focus();
      }
    });

  /* ---------- Cart drawer ---------- */
  const cartDrawer = $('[data-cart-drawer]');
  const cartItems = $('[data-cart-items]');
  const cartFoot = $('[data-cart-foot]');

  function openCart() {
    cartDrawer && cartDrawer.classList.add('open');
    overlay && overlay.classList.add('open');
  }
  function closeCart() {
    cartDrawer && cartDrawer.classList.remove('open');
    overlay && overlay.classList.remove('open');
  }
  $$('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); openCart(); }));
  $$('[data-cart-close]').forEach((b) => b.addEventListener('click', closeCart));
  overlay && overlay.addEventListener('click', () => { closeCart(); closeMobile(); });

  function money(cents) {
    const fmt = window.themeSettings.moneyFormat || '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  function renderCart(cart) {
    if (!cartItems) return;
    const countEls = $$('[data-cart-count]');
    countEls.forEach((el) => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
    const titleCount = $('[data-cart-title-count]');
    if (titleCount) titleCount.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';

    if (cart.item_count === 0) {
      cartItems.innerHTML =
        '<div class="cart-empty-state">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 7h12l1.5 13.5a1 1 0 0 1-1 1.1H5.5a1 1 0 0 1-1-1.1L6 7z"/><path d="M9 10V6a3 3 0 0 1 6 0v4"/></svg>' +
        '<p class="display">Your cart is empty</p>' +
        '<p>Fill it with something stitched just for you.</p>' +
        '<a href="/collections/all" class="btn btn-dark" data-cart-close-link>Start shopping</a></div>';
      cartFoot.style.display = 'none';
      $$('[data-cart-close-link]').forEach((a) => a.addEventListener('click', closeCart));
      return;
    }

    cartItems.innerHTML = cart.items
      .map(function (item) {
        const img = item.image
          ? '<img src="' + item.image.replace(/(\.[^.]*)$/, '_120x$1') + '" alt="">'
          : '';
        return (
          '<div class="cart-drawer-item" data-line="' + item.key + '">' +
          img +
          '<div class="cart-drawer-item-info">' +
          '<div class="cart-drawer-item-top">' +
          '<a href="' + item.url + '" class="cart-drawer-item-title">' + item.product_title + '</a>' +
          '<button class="cart-drawer-remove" data-remove="' + item.key + '" aria-label="Remove">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2m3 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/></svg>' +
          '</button></div>' +
          (item.variant_title ? '<p class="cart-drawer-item-meta">' + item.variant_title + '</p>' : '') +
          '<div class="cart-drawer-item-bottom">' +
          '<div class="qty-box small">' +
          '<button data-qty="' + item.key + '|' + (item.quantity - 1) + '" aria-label="Decrease">−</button>' +
          '<input type="text" value="' + item.quantity + '" readonly>' +
          '<button data-qty="' + item.key + '|' + (item.quantity + 1) + '" aria-label="Increase">+</button>' +
          '</div>' +
          '<span class="cart-drawer-item-price">' + money(item.final_line_price) + '</span>' +
          '</div></div></div>'
        );
      })
      .join('');

    const subtotalEl = $('[data-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    cartFoot.style.display = 'block';

    $$('[data-remove]', cartItems).forEach((b) =>
      b.addEventListener('click', () => changeLine(b.getAttribute('data-remove'), 0))
    );
    $$('[data-qty]', cartItems).forEach((b) => {
      const parts = b.getAttribute('data-qty').split('|');
      b.addEventListener('click', () => changeLine(parts[0], parseInt(parts[1], 10)));
    });
  }

  function fetchCart() {
    return fetch('/cart.js').then((r) => r.json()).then(renderCart);
  }

  function changeLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    })
      .then((r) => r.json())
      .then(renderCart);
  }

  // Refresh drawer contents whenever opened
  $$('[data-cart-open]').forEach((b) => b.addEventListener('click', fetchCart));

  /* ---------- Product form (AJAX add to cart) ---------- */
  const productForm = $('[data-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = $('[data-add-button]', productForm);
      const id = $('[name="id"]', productForm).value;
      const qty = parseInt(($('[name="quantity"]', productForm) || {}).value || '1', 10);
      if (!id) return;
      btn.disabled = true;
      btn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: qty }] }),
      })
        .then((r) => r.json())
        .then(() => fetchCart())
        .then(() => {
          btn.textContent = 'Added to cart ✓';
          setTimeout(() => {
            btn.disabled = false;
            btn.textContent = btn.getAttribute('data-label') || 'Add to cart';
            openCart();
          }, 500);
        })
        .catch(() => {
          btn.disabled = false;
          btn.textContent = 'Try again';
        });
    });
  }

  /* ---------- Variant picker ---------- */
  const variantWrap = $('[data-variant-picker]');
  if (variantWrap) {
    const variants = JSON.parse(variantWrap.getAttribute('data-variants'));
    const idInput = $('[name="id"]', productForm);
    const priceEl = $('[data-pdp-price]');
    const addBtn = $('[data-add-button]');

    function currentSelection() {
      return $$('.option-values', variantWrap).map((group) => {
        const sel = $('.option-value.selected', group);
        return sel ? sel.getAttribute('data-value') : null;
      });
    }

    function findVariant() {
      const sel = currentSelection();
      return variants.find((v) => v.options.every((opt, i) => sel[i] === null || opt === sel[i]));
    }

    $$('.option-value', variantWrap).forEach((btn) => {
      btn.addEventListener('click', function () {
        const group = this.closest('.option-values');
        $$('.option-value', group).forEach((b) => b.classList.remove('selected'));
        this.classList.add('selected');
        const v = findVariant();
        if (v) {
          idInput.value = v.id;
          if (priceEl) {
            priceEl.innerHTML = v.compare_at_price && v.compare_at_price > v.price
              ? '<s>' + money(v.compare_at_price) + '</s><span class="sale-price">' + money(v.price) + '</span>'
              : money(v.price);
          }
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? (addBtn.getAttribute('data-label') || 'Add to cart') : 'Sold out';
        }
      });
    });
  }

  /* ---------- PDP gallery ---------- */
  const mainMedia = $('[data-pdp-main]');
  if (mainMedia) {
    $$('[data-pdp-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', function () {
        $$('[data-pdp-thumb]').forEach((t) => t.classList.remove('active'));
        this.classList.add('active');
        mainMedia.src = this.getAttribute('data-full');
      });
    });
  }

  /* ---------- Accordions ---------- */
  $$('[data-accordion-head]').forEach((head) => {
    head.addEventListener('click', function () {
      const body = this.nextElementSibling;
      this.classList.toggle('open');
      body && body.classList.toggle('open');
    });
  });

  /* ---------- Collection sort ---------- */
  const sortSelect = $('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Initial cart count ---------- */
  if (cartDrawer) fetchCart();
})();
